<template>
    <div class="archives">
        <common-title titleName="我的档案" :isAPPShow="true"/>
        <ProgressBar
          :current="current"
          :total="total"
        />
        <div class="content">
          <ul>
            <li v-show="current === 1">
              <h5 class="title">1.请输入你的姓名</h5>
              <input
                v-model="archivesInfo.realName"
                class="inputBox"
                type="text"
                maxlength="10"
                placeholder="请输入你的姓名"
              >
            </li>
            <li v-show="current === 2">
              <h5 class="title">2.你当前就读（毕业）的院校和专业是？</h5>
              <TextBox
                placeholder="请选择学校"
                :text="archivesInfo.ugCollege"
                @click.native="arousePopupShow(1)"
              />
              <TextBox
                placeholder="请选择专业"
                :text="archivesInfo.ugSubject"
                @click.native="arousePopupShow(2,1)"
              />
            </li>
            <li v-show="current === 3">
              <h5 class="title">3.你的考研目标院校是？</h5>
              <TextBox
                :disabled="schoolUn"
                placeholder="请选择目标学校"
                :text="archivesInfo.beTgSchool"
                @click.native="arousePopupShow(3)"
              />
              <TextBox
                text="我还没想好"
                :iconShow="false"
                :isCheck="schoolUn"
                @click.native="schoolUn = !schoolUn"
              />
            </li>
            <li v-show="current === 4">
              <h5 class="title">4.你的考研目标专业是？</h5>
              <TextBox
                :disabled="subjectUn"
                placeholder="请选择目标专业"
                :text="archivesInfo.beTgSubject"
                @click.native="arousePopupShow(2)"
              />
              <TextBox
                text="我还没想好"
                :iconShow="false"
                :isCheck="subjectUn"
                @click.native="subjectUn = !subjectUn"
              />
            </li>
            <li v-show="current === 5">
              <h5 class="title">5.你的跨考情况是？</h5>
              <RadioChoice
                :checkId="archivesInfo.beCrossInfo"
                :radioList="beCrossArr"
                @checkRadio="checkRadio"
              />
            </li>
            <li v-show="current === 6">
              <h5 class="title">6.你当前所处的阶段是？</h5>
              <RadioChoice
                :checkId="archivesInfo.learnType"
                :radioList="learnTypeArr"
                @checkRadio="checkRadio"
              />
            </li>
            <li v-show="current === 7">
              <h5 class="title">7.你是否二战？</h5>
              <RadioChoice
                :checkId="archivesInfo.beAgain"
                :radioList="beAgainArr"
                @checkRadio="checkRadio"
              />
            </li>
            <li v-show="current === 8">
              <h5 class="title">8.你的英语四六级分数是？</h5>
              <div class="cet">
                <p>四级分数</p>
                <input
                  v-model="archivesInfo.beCet4Score"
                  :disabled="cet4Un"
                  @input="reg(archivesInfo.beCet4Score,1)"
                  class="inputBox"
                  type="number"
                  placeholder="请输入你的英语四级考试成绩"
                >
                 <TextBox
                  text="我没有参与四级考试"
                  :iconShow="false"
                  :isCheck="cet4Un"
                  @click.native="cet4Click"
                />
              </div>
              <div class="cet">
                <p>六级分数</p>
                  <!-- :disabled="cet4Un || cet6Un || !archivesInfo.beCet4Score" -->
                  <!-- :disabled="cet4Un || !archivesInfo.beCet4Score" -->

                <input
                  v-model="archivesInfo.beCet6Score"
                  :disabled="cet4Un || cet6Un"
                  @input="reg(archivesInfo.beCet6Score,2)"
                  class="inputBox"
                  type="number"
                  placeholder="请输入你的英语六级考试成绩"
                >
                 <TextBox
                  :disabled="cet4Un"
                  text="我没有参与六级考试"
                  :iconShow="false"
                  :isCheck="cet6Un"
                  @click.native="cet6Click"
                />
              </div>
            </li>
            <li v-show="current === 9">
              <h5 class="title">9.请最后确认一下你的信息是否有误</h5>
              <ArchivesInfo  :info="subArchivesInfo" />
            </li>
          </ul>
        </div>
        <PopupSelect
          v-if="showPopup"
          :type="selectType"
          @closePopup="showPopup = false"
          @selectInfo="selectInfo"
          :idx="idx"
        />
        <div class="bottomFixed">
          <div v-if="current < total">
            <p v-show="current !== 1" @click="backStep">上一步</p>
            <p :class="{done: !done}" @click="nextStep">下一步</p>
          </div>
          <div v-else>
            <p @click="current = 1">重新填写</p>
            <p @click="submit">确认提交</p>
          </div>
        </div>
    </div>
</template>
<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import ProgressBar from '@/components/progressBar/index.vue';
import _ from 'lodash';
import { getArchivesInfoApi, subArchivesInfoApi } from '@/api/archives';
import { mapState } from 'vuex';
import TextBox from './components/textBox.vue';
import RadioChoice from './components/radioChoice.vue';
import PopupSelect from './components/popupSelect.vue';
import ArchivesInfo from './components/archivesInfo.vue';

export default {
  data() {
    return {
      total: 9, // 总题数
      current: 1, // 当前题数
      showPopup: false, // 选择院校弹窗
      selectType: 1, // 1 本科学校 2 专业 3 目标学校
      schoolUn: false, // true 学校还没想好
      subjectUn: false, // true 专业还没想好
      cet4Un: false, // 没参加4级
      cet6Un: false, // 没参加6级
      archivesInfo: {
        realName: '', // 真实姓名
        ugCollege: '', // 本科学校
        ugSubject: '', // 本科专业
        beTgSchool: '', // 目标院校
        beTgSubject: '', // 目标专业
        beCrossInfo: '', // 跨考信息
        learnType: '', // 学员所处阶段
        beAgain: '', // 是否二战
        beCet4Score: '', // 四级成绩
        beCet6Score: '', // 六级成绩
      },
      // archivesInfo: {
      //   realName: '奥德赛', // 真实姓名
      //   ugCollege: '北京大学', // 本科学校
      //   ugSubject: '建筑环境与能源应用工程专业', // 本科专业
      //   beTgSchool: '', // 目标院校
      //   beTgSubject: '建筑', // 目标专业
      //   beCrossInfo: 0, // 跨考信息
      //   learnType: 1, // 学员所处阶段
      //   beAgain: 1, // 是否二战
      //   beCet4Score: '123', // 四级成绩
      //   beCet6Score: '', // 六级成绩
      // },
      subArchivesInfo: null, // 最终提交时的数据
      beCrossArr: [
        {
          id: 0,
          title: '跨校跨专业',
        },
        {
          id: 1,
          title: '跨校不跨专业',
        },
        {
          id: 2,
          title: '不跨校跨专业',
        },
        {
          id: 3,
          title: '本校本专业',
        },
        {
          id: 4,
          title: '我还没想好',
        },
      ],
      learnTypeArr: [
        {
          id: 3,
          title: '大二',
        },
        {
          id: 4,
          title: '大三',
        },
        {
          id: 5,
          title: '大四',
        },
        {
          id: 1,
          title: '在职',
        },
        {
          id: 2,
          title: '脱产',
        },
        {
          id: 6,
          title: '专升本',
        },
      ],
      beAgainArr: [
        {
          id: 1,
          title: '是',
        },
        {
          id: 0,
          title: '否',
        },
      ],
      idx:0
    };
  },
  components: {
    CommonTitle,
    ProgressBar,
    TextBox,
    RadioChoice,
    PopupSelect,
    ArchivesInfo,
  },
  watch: {
    current(value) { // 处理数据
      if (value !== 9) return;
      let obj = _.cloneDeep(this.archivesInfo);
      let {
        beCet4Score, beCet6Score, beTgSchool, beTgSubject, beCrossInfo,
      } = obj;
      if (this.schoolUn) beTgSchool = ''; // 学校没想好
      if (this.subjectUn) beTgSubject = ''; // 专业没想好
      if (beCrossInfo === 4) beCrossInfo = ''; // 跨考信息没想好
      if (this.cet4Un) { // 四级没考
        beCet4Score = '';
        beCet6Score = '';
      } else if (this.cet6Un) { // 六级没考
        beCet6Score = '';
      }
      obj = {
        ...obj,
        beTgSchool,
        beTgSubject,
        beCrossInfo,
        beCet4Score,
        beCet6Score,
        userId: this.userInfo.id,
      };
      this.subArchivesInfo = obj;
    },
  },
  computed: {
    ...mapState(['userInfo']),
    done() { // 当前题目  true 已做 false 未做
      const {
        realName, ugCollege, ugSubject, beTgSchool, beTgSubject, beCrossInfo, learnType, beAgain, beCet4Score, beCet6Score,
      } = this.archivesInfo;
      let done = false;
      switch (this.current) {
        case 1:
          done = realName && !!realName.trim();
          break;
        case 2:
          done = ugCollege && ugSubject;
          break;
        case 3:
          done = beTgSchool || this.schoolUn;
          break;
        case 4:
          done = beTgSubject || this.subjectUn;
          break;
        case 5:
          done = beCrossInfo !== null && Boolean(`${beCrossInfo}`);
          break;
        case 6:
          done = learnType !== null && Boolean(`${learnType}`);
          break;
        case 7:
          done = beAgain !== null && Boolean(`${beAgain}`);
          break;
        case 8:
          if (this.cet4Un) {
            done = true;
          } else if (beCet4Score && (this.cet6Un || beCet6Score)) {
            done = true;
          } else {
            done = false;
          }
          break;
        default:
          done = false;
          break;
      }
      return done;
    },
  },
  methods: {
    async getArchivesInfo() {
      const data = await getArchivesInfoApi();
      if (data.code === 0) {
        this.archivesInfo = data.data;
      }
    },
    checkRadio(value) {
      switch (this.current) {
        case 5:
          this.archivesInfo.beCrossInfo = value;
          break;
        case 6:
          this.archivesInfo.learnType = value;
          break;
        case 7:
          this.archivesInfo.beAgain = value;
          break;
        default:
          break;
      }
    },
    arousePopupShow(type,idx) {
      if (this.current === 3 && this.schoolUn) {
        return;
      } if (this.current === 4 && this.subjectUn) {
        return;
      }
      this.idx=idx||0
      this.selectType = type;
      this.showPopup = true;
    },
    selectInfo(value) {
      switch (this.current) {
        case 2:
          if (this.selectType === 1) {
            this.archivesInfo.ugCollege = value;
          } else {
            this.archivesInfo.ugSubject = value;
          }
          break;
        case 3:
          this.archivesInfo.beTgSchool = value;
          break;
        case 4:
          this.archivesInfo.beTgSubject = value;
          break;
        default:
          break;
      }
    },
    reg(value, type) {
      let data = value.match(/\d+(\.\d{0,2})?/) ? value.match(/\d+(\.\d{0,2})?/)[0] : '';
      data = data > 999 ? 999 : data;
      data = data < 0 ? 0 : data;
      if (type === 1) {
        this.archivesInfo.beCet4Score = data;
      } else {
        this.archivesInfo.beCet6Score = data;
      }
    },
    cet4Click() {
      this.cet4Un = !this.cet4Un;
      if (this.cet4Un) {
        this.cet6Un = false;
      }
    },
    cet6Click() {
      if (this.cet4Un) return;
      this.cet6Un = !this.cet6Un;
    },
    nextStep() {
      if (!this.done) return;
      this.current += 1;
    },
    backStep() {
      this.current -= 1;
    },
    async submit() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      const data = await subArchivesInfoApi(this.subArchivesInfo);
      this.$toast.clear();
      if (data.code === 0) {
        this.$toast.success('提交成功');
        setTimeout(() => {
          // if (this.$root.$data.isApp && !this.$route.query.back) { // APP直接进入改页面 非我的档案进入
          //   this.$sendToApp('closePage');
          // } else {
          // }
          if (this.$route.query.back) {
            this.$router.go(-1);
            return;
          }
          this.$router.replace({
            path: '/ownarchives',
          });
        }, 2000);
      } else {
        this.$toast.fail(data.msg);
      }
    },
  },
  mounted() {
    this.getArchivesInfo();
  },
};
</script>
<style lang="scss" scoped>
.archives {
  min-height: 100vh;
  padding: 100px 0 150px;
  background: #fff;
  .content {
    margin-top: 80px;
    li {
      width: 100%;
      font-size: 33px;
      text-align: center;
      .title {
        margin-bottom: 58px;
      }
      .inputBox {
        width: 605px;
        height: 91px;
        padding: 0 36px;
        font-size: 25px;
        border: 2px solid #E8E8E8;
        border-radius: 45px;
      }
      ::-webkit-input-placeholder {
        color: #999;
      }
      .cet {
        margin-bottom: 80px;
        padding: 0 72px;
        p {
          margin-bottom: 40px;
          text-align: left;
        }
      }
    }
  }
  input:disabled, input[disabled] {
    -webkit-background:#9fa8b533;
    background: #9fa8b533;
    -webkit-opacity:1;
    opacity: 1;
  }
  .bottomFixed {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 140px;
    background: #fff;
    div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: inherit;
      padding: 0 36px;
      font-size: 29px;
      p:first-child {
        width: 50%;
        margin-right: 20px;
        color: #FF7F41;
        background: initial;
      }
      p {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 80px;
        color: #fff;
        background: #FF7F41;
        border: 2px solid #FF7F41;
        border-radius: 45px;
      }
      .done {
        background: #DCDCDC;
        border: initial;
      }
    }
  }
}
</style>
